import { render, staticRenderFns } from "./LayoutDefault.vue?vue&type=template&id=70d28a46&scoped=true&"
import script from "./LayoutDefault.vue?vue&type=script&lang=js&"
export * from "./LayoutDefault.vue?vue&type=script&lang=js&"
import style0 from "./LayoutDefault.vue?vue&type=style&index=0&id=70d28a46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d28a46",
  null
  
)

export default component.exports